import Axios from "axios";
import { authorizationHeader } from "./apiUtils";
import { PageSettings } from "../models/misc";

const baseRoute = "/api/pagesettings";

export async function getPageSettings(pageName: string): Promise<PageSettings> {
  const response = await Axios.get<PageSettings>(
    `${baseRoute}/${encodeURIComponent(pageName)}`,
    { headers: authorizationHeader() }
  );
  return response.data;
}

export async function getAllPageSettings(): Promise<PageSettings[]> {
  const response = await Axios.get<PageSettings[]>(
    baseRoute,
    { headers: authorizationHeader() }
  );
  return response.data;
}

export async function createPageSettings(pageName: string): Promise<PageSettings> {
  const response = await Axios.post<PageSettings>(
    baseRoute,
    { pageName },
    { headers: authorizationHeader() }
  );
  return response.data;
}

export async function deletePageSettings(pageName: string): Promise<void> {
  await Axios.delete(
    `${baseRoute}/${encodeURIComponent(pageName)}`,
    { headers: authorizationHeader() }
  );
}

export async function updatePageSettings(settings: PageSettings): Promise<PageSettings> {
  const response = await Axios.put<PageSettings>(
    `${baseRoute}/${encodeURIComponent(settings.pageName)}`,
    settings,
    { headers: authorizationHeader() }
  );
  return response.data;
}